import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
//import Test from '../views/Test.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import(/* webpackChunkName: "shop" */ '../views/Shop.vue'),
  },
  {
    path: '/products/:uri',
    name: 'Product',
    component: () => import(/* webpackChunkName: "buy" */ '../views/product.vue'),
    beforeEnter: (to, from, next) => {
      if(to.params.uri == "lite-e-series"){
        next({ path: "/products/robotics-advanced-kit-er"})
      }else if(to.params.uri == "intro-e-series"){
        next({ path: "/products/robotics-starter-kit"})
      }else if(to.params.uri == "full-e-series"){
        next({ path: "/products/robotics-pro-kit-er"})
      }else{
        next();
      }
    }
  },
  {
    path: '/courses/:code',
    name: 'Course',
    component: () => import(/* webpackChunkName: "buy" */ '../views/course.vue'),
  },
  {
    path: '/course/feedback',
    name: 'Nps',
    component: () => import(/* webpackChunkName: "buy" */ '../views/courseFeedback.vue'),
  },
  {
    path: '/my-courses',
    name: 'MyCourses',
    component: () => import(/* webpackChunkName: "buy" */ '../views/myCourses.vue'),
  },
  {
     path: '/buy',
     name: 'Buy',
     component: () => import(/* webpackChunkName: "buy" */ '../views/Buy.vue'),
  },
  {
    path: '/review',
    name: 'Review',
    props: true,
    component: () => import(/* webpackChunkName: "shop" */ '../views/Review.vue'),
  },
  {
    path: '/downloads',
    name: 'Downloads',
    component: () => import(/* webpackChunkName: "downloads" */ '../views/Downloads.vue'),
  },
  {
    path: '/club-purchase/:token',
    name: 'BuyBbc',
    component: () => import(/* webpackChunkName: "club-purchase" */ '../views/BuyBbc.vue'),
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutUs.vue'),
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "buy" */ '../views/Test.vue'),
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
  },
  {
    path: '/project/:code',
    name: 'Project',
    component: () => import(/* webpackChunkName: "projects" */ '../views/Project.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
  },
  {
    path: '/profile/settings',
    name: 'profileSettings',
    component: () => import(/* webpackChunkName: "profile" */ '../views/profileSettings.vue'),
  },
  {
    path: '/user/:userName',
    name: 'userProfile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/userProfile.vue'),
  },
  {
    path: '/workshop/:workshop_code',
    name: 'workshop',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Workshop.vue'),
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
  // {
  //   path: '/user/:id',
  //   name: 'User',
  //   component: () => import(/* webpackChunkName: "user" */ '../views/User.vue'),
  // },
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  }
});

export default router;
